// Local URL (keep for reference)
// export const Baseurl = "http://localhost:4000";
// export const Baseurl2 = "http://localhost:4000";

// Live backend URL only
export const Baseurl = "https://mygoldenhomeswebsiteapi.dexterous.in";
export const Baseurl2 = "https://mygoldenhomeswebsiteapi.dexterous.in";